// src/components/PhotoModal.jsx
import React from 'react';
import { X, Calendar, Trash2, Film } from 'lucide-react';

const PhotoModal = ({ photo, onClose, isAdmin, onDelete }) => {
    const isVideo = photo.type === 'video';

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/90 backdrop-blur-sm"
            onClick={onClose}
        >
            <div
                className="relative max-w-5xl w-full bg-white rounded-2xl overflow-hidden shadow-2xl"
                onClick={e => e.stopPropagation()}
            >
                {/* Close Button */}
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 z-10 p-2 bg-black/20 hover:bg-black/40
                             backdrop-blur-sm rounded-full transition-all duration-200
                             transform hover:rotate-90"
                    aria-label="Close modal"
                >
                    <X className="w-6 h-6 text-white" />
                </button>

                {/* Media Container */}
                <div className="relative aspect-video bg-black">
                    {isVideo ? (
                        <video
                            src={photo.fileUrl}
                            className="w-full h-full object-contain"
                            controls
                            autoPlay
                        />
                    ) : (
                        <img
                            src={photo.fileUrl}
                            alt={photo.title}
                            className="w-full h-full object-contain"
                        />
                    )}

                    {/* Media Type Indicator */}
                    {isVideo && (
                        <div className="absolute top-4 left-4 p-2 bg-black/20 backdrop-blur-sm rounded-lg">
                            <Film className="w-5 h-5 text-white" />
                        </div>
                    )}
                </div>

                {/* Content Section */}
                <div className="p-6">
                    <div className="flex items-start justify-between gap-4">
                        <div className="flex-1">
                            <h2 className="text-2xl font-semibold text-gray-900 mb-2">
                                {photo.title}
                            </h2>

                            <div className="flex items-center gap-4 text-sm text-gray-500">
                                <div className="flex items-center gap-1.5">
                                    <Calendar className="w-4 h-4" />
                                    <span>{photo.date}</span>
                                </div>
                                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium
                                               bg-purple-100 text-purple-800">
                                    {photo.category}
                                </span>
                            </div>
                        </div>

                        {isAdmin && (
                            <button
                                onClick={() => {
                                    onDelete(photo.$id, photo.imageId);
                                    onClose();
                                }}
                                className="flex items-center gap-2 px-4 py-2 text-red-600 hover:text-red-700
                                         hover:bg-red-50 rounded-lg transition-colors"
                            >
                                <Trash2 className="w-4 h-4" />
                                <span>Delete</span>
                            </button>
                        )}
                    </div>

                    {photo.content && (
                        <div className="mt-6">
                            <h3 className="text-sm font-medium text-gray-700 mb-2">Description</h3>
                            <p className="text-gray-600 whitespace-pre-wrap">
                                {photo.content}
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PhotoModal;